import { api } from '@cloudsuite/theme_library/scripts/helper';

const retrieveTreeParents =  [...document.querySelectorAll('[data-js-retrieve-tree]')];

if(retrieveTreeParents.length) {
     retrieveTreeParents.forEach(item => {
         const {
             treeParentsUrl,
             ega,
           } = item.dataset;
     
         let dataEga =  JSON.parse(ega);
     
         dataEga.products.map(async product => {
             let cat = await api.get(treeParentsUrl.replace('999999', product.treeID))
             .then((trees) => {
                 return trees.map(tree => tree.name).join('/');
             });
             
             Object.assign(product, {category: `${cat}/${product.tree_name}`});
     
             item.setAttribute('data-ega', JSON.stringify(dataEga))
         })
     });
 }